import { formatDateForInput } from "../../../../shared/utils/formatDate";
import { Grid, TextField } from "../../../../shared/utils/muiImports";
import { AdmissionDetailsProps } from "../User.type";

const AdmissionInformationForm: React.FC<AdmissionDetailsProps> = ({
  admissionDetails,
  onChange,
  errors,
}) => {
  return (
    <>
      <Grid item xs={12} md={6}>
        <TextField
          label="Hospital (Location)"
          name="admissionDetails.hospitalLocation"
          fullWidth
          margin="none"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={admissionDetails?.hospitalLocation}
        ></TextField>
      </Grid>

      <Grid item xs={12} md={3}>
        <TextField
          label="Admission Date"
          name="admissionDetails.admissionDate"
          fullWidth
          margin="none"
          size="small"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={admissionDetails?.admissionDate}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label="Consulting Doctor"
          name="admissionDetails.doctor"
          fullWidth
          margin="none"
          size="small"
          value={admissionDetails?.doctor}
          InputLabelProps={{ shrink: true }}
        ></TextField>
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label="Expected Discharge Date"
          name="expectedDischargeDate"
          fullWidth
          margin="none"
          size="small"
          type="date"
          value={admissionDetails?.expectedDischargeDate}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <TextField
          label="Discharge Date"
          name="dischargeDate"
          fullWidth
          margin="none"
          size="small"
          type="date"
          value={admissionDetails?.dischargeDate}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <TextField
          label="Consultation Date & Time"
          name="consultationDateTime"
          fullWidth
          margin="none"
          size="small"
          type="datetime-local"
          value={admissionDetails?.consultationDateTime}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
    </>
  );
};

export default AdmissionInformationForm;
